import { makeStyles } from "@material-ui/core/styles";

export const useEncodingStatusFieldStyles = makeStyles({
  popover: {
    padding: "10px",
  },
});
